import(/* webpackMode: "eager" */ "/app/apps-node/webapp/src/app/global-error.tsx");
